










































































































































































































































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
// helpers
//import { idtify } from "@/helpers/string";
// tipos
//import { Rutas } from "@/typings/store/modules/rutas";
//import {
//  Permisos,
//  TipoUsuario,
//  Usuario,
//} from "@/typings/store/plugins/easyFirestore/usuarios";
import {
  CondicionDivision,
  //Bancos
} from "@/typings/store/plugins/easyFirestore/condicionesDivisiones";
// validaciones
import {
  // email,
  required,
} from "vuelidate/lib/validators";
import { DataFormularioCondicionDivision } from "@/typings/components/condicionesDivisiones/formulario";
import SVGIcon from "@/components/SVGIcon.vue";
import { Contrato } from "@/typings/store/plugins/easyFirestore/contratos";
import { CondicionComercial } from "@/typings/store/plugins/easyFirestore/condicionesComerciales";
import { aNumero } from "@/helpers/facturacion";
import { aFecha } from "@/helpers/fechas";
//import { Archivo, Archivos } from "@/typings/store/modules/archivos";

const mayorQueCero = (valor: unknown): boolean => Number(valor) > 0;
const numeroValido = (valor: unknown): boolean =>
  String(valor ?? "").trim() !== "" && aNumero(valor) >= 0;

@Component({
  components: {
    SVGIcon,
  },
  validations: {
    // nombre: { required },
    // posicion: { required },
    codigoDivision: { required },
    nombreDivision: { required },
    moneda: { required },
    escala: { required },
    indexacion: { required },
    minimo: { required, numeroValido },
    aporte: { required },
    operador: { required },
    origen: { required },
    codigoContrato: { required, mayorQueCero },
    codigoCondicion: { required, mayorQueCero },
  },
})
export default class FormularioCondicionDivision extends Vue {
  @Prop() readonly condicionDivision!: CondicionDivision | null;
  @Prop() readonly cargando!: boolean;
  /** Si se abre desde un contrato: fija el código y ofrece sus condiciones. */
  @Prop({ default: null }) readonly contrato!: Contrato | null;
  @Prop({ default: () => [] }) readonly condiciones!: CondicionComercial[];

  get opcionesCondicion(): Array<{ text: string; value: number }> {
    const fecha = (v: unknown) => aFecha(v)?.toLocaleDateString("es-CL") ?? "?";
    return this.condiciones.map((c) => ({
      text: `${c.codigo_condicion} · ${fecha(c.desde)} a ${fecha(c.hasta)}`,
      value: Number(c.codigo_condicion),
    }));
  }
  //   @Prop() readonly rutas!: Rutas;
  //   @Prop() readonly ciudades!: Ciudad[];
  //   @Prop() readonly cargando!: boolean;
  //   @Prop() readonly regiones!: Region[];

  created(): void {
    // Object.keys(this.rutas).forEach((key) => {
    //   this.$set(this.permisos, key, false);
    // });
    // console.log(this.permisos);
    if (this.contrato) {
      this.codigoContrato = this.contrato.codigo;
      const ultima = this.opcionesCondicion[this.opcionesCondicion.length - 1];
      if (ultima) this.codigoCondicion = ultima.value;
    }
    const condicionDivision = this.condicionDivision;
    if (!condicionDivision) {
      return;
    }
    this.id = condicionDivision.id ?? "";
    // this.nombre = condicionDivision.nombre;
    // this.posicion = condicionDivision.posicion ?? "";

    this.codigoDivision = Number(condicionDivision.codigo_division) || 0;
    this.nombreDivision = condicionDivision.nombre_division ?? "";
    this.moneda = condicionDivision.moneda ?? "";
    this.escala = condicionDivision.escala ?? "";
    this.indexacion = condicionDivision.indexacion ?? "";
    this.minimo = condicionDivision.minimo ?? 0;
    this.porcentaje = condicionDivision.porcentaje
      ? String(Math.round(condicionDivision.porcentaje * 10000) / 100)
      : "";
    this.descripcion = condicionDivision.descripcion ?? "";
    this.base = condicionDivision.base || "MONTO FIJO";
    this.exento = !!condicionDivision.exento;
    this.aporte = condicionDivision.aporte ?? "";
    this.operador = condicionDivision.operador ?? "";
    this.origen = condicionDivision.origen ?? "";
    this.codigoContrato = Number(condicionDivision.codigo_contrato) || 0;
    this.codigoCondicion = Number(condicionDivision.codigo_condicion) || 0;
  }

  id: string | null = null;

  // nombre = "";
  // posicion = "";
  codigoDivision = 0;
  nombreDivision = "";
  moneda = "";
  escala = "";
  indexacion = "";
  minimo = 0;
  /** En la pantalla se escribe en % (6 = 6%); se guarda como fracción (0.06). */
  porcentaje = "";

  /** Otro Cobro: un cargo extra del contrato (bodega, internet…), por m² o monto fijo, afecto o exento. */
  descripcion = "";
  base = "MONTO FIJO";
  exento = false;
  itemsBase = [
    { text: "Monto fijo", value: "MONTO FIJO" },
    { text: "Por m²", value: "POR M2" },
  ];

  get esOtroCobro(): boolean {
    return (this.nombreDivision || "").toUpperCase() === "OTRO COBRO";
  }

  get etiquetaMinimo(): string {
    const unidad = (this.indexacion || "").toUpperCase().includes("UNIDAD DE FOMENTO") ? "UF" : "$";
    if (this.esOtroCobro && this.base !== "POR M2") return `Monto (${unidad})`;
    return `Mínimo (${unidad} × m²)`;
  }

  get descripcionError(): Array<string> {
    return this.esOtroCobro && this.$v.$dirty && !this.descripcion.trim() ? ["Indica qué se cobra"] : [];
  }

  get usaPorcentaje(): boolean {
    const division = (this.nombreDivision || "").toUpperCase();
    return (
      division === "ALQUILER VARIABLE" ||
      (division.startsWith("FDO. PROMOCION") && ["ALQUILER", "ALQUILER FIJO"].includes((this.origen || "").toUpperCase()))
    );
  }

  get etiquetaPorcentaje(): string {
    return (this.nombreDivision || "").toUpperCase() === "ALQUILER VARIABLE"
      ? "% sobre ventas"
      : "% sobre el arriendo";
  }

  get porcentajeError(): Array<string> {
    if (!this.usaPorcentaje || this.porcentaje === "") return [];
    const valor = aNumero(this.porcentaje);
    return valor > 0 && valor <= 100 ? [] : ["Entre 0 y 100"];
  }
  aporte = "";
  operador = "";
  origen = "";
  codigoContrato = 0;
  codigoCondicion = 0;

  itemsCodDivision = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  itemsDivision = [
    "Alquiler Fijo",
    "Alquiler Variable",
    "Gastos Comunes",
    "Fdo. Promocion Fijo",
    "Fdo. Promocion Variable",
    "Otro Cobro",
  ];
  itemsMoneda = ["PESOS CHILENOS", "DOLARES"];
  itemsEscala = ["DIRECTA", "PROGRESIVA", "NO APLICA"];
  itemsIndexacion = ["UNIDAD DE FOMENTO - INDEXACION", "PESOS CHILENOS"];
  itemsAporte = ["SI", "NO", "NO APLICA"];
  itemsOperador = ["SIN MINIMO", "OPCION", "MAS", "NO APLICA"];
  itemsOrigen = ["VEN/NETAS", "VEN/BRUTAS", "ALQUILER", "ALQUILER FIJO", "NO APLICA"];

  get titulo(): string {
    return this.condicionDivision
      ? "editar condicionDivision"
      : "nuevo condicionDivision";
  }

  //   get permisosKey(): Array<string> {
  //     // return Object.keys(this.permisos).filter((key) => {
  //     //   if(this.rutas[key].tipos.includes(this.tipo)){
  //     //     this.permisos[key] = true;
  //     //   }
  //     // });
  //     return Object.keys(this.permisos).filter((key) => {
  //       if (!this.rutas[key]) {
  //         return false;
  //       }
  //       const tipo = this.rutas[key].tipos.includes(this.tipo);
  //       return tipo;
  //     });
  //   }

  get codigoDivisionError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.codigoDivision.$dirty) return errors;
    if (!this.$v.codigoDivision.required)
      errors.push("Completar datos obligatorios");
    return errors;
  }

  get nombreDivisionError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.nombreDivision.$dirty) return errors;
    if (!this.$v.nombreDivision.required)
      errors.push("Completar datos obligatorios");
    return errors;
  }

  get monedaError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.moneda.$dirty) return errors;
    if (!this.$v.moneda.required) errors.push("Completar datos obligatorios");
    return errors;
  }

  get escalaError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.escala.$dirty) return errors;
    if (!this.$v.escala.required) errors.push("Completar datos obligatorios");
    return errors;
  }

  get indexacionError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.indexacion.$dirty) return errors;
    if (!this.$v.indexacion.required)
      errors.push("Completar datos obligatorios");
    return errors;
  }

  get minimoError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.minimo.$dirty) return errors;
    if (!this.$v.minimo.required) errors.push("Completar datos obligatorios");
    else if (!this.$v.minimo.numeroValido) errors.push("Debe ser un número, p. ej. 0,45");
    return errors;
  }

  get aporteError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.aporte.$dirty) return errors;
    if (!this.$v.aporte.required) errors.push("Completar datos obligatorios");
    return errors;
  }

  get operadorError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.operador.$dirty) return errors;
    if (!this.$v.operador.required) errors.push("Completar datos obligatorios");
    return errors;
  }

  get origenError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.origen.$dirty) return errors;
    if (!this.$v.origen.required) errors.push("Completar datos obligatorios");
    return errors;
  }

  get codigoContratoError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.codigoContrato.$dirty) return errors;
    if (!this.$v.codigoContrato.required)
      errors.push("Completar datos obligatorios");
    else if (!this.$v.codigoContrato.mayorQueCero) errors.push("Indica el contrato");
    return errors;
  }

  get codigoCondicionError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.codigoCondicion.$dirty) return errors;
    if (!this.$v.codigoCondicion.required)
      errors.push("Completar datos obligatorios");
    else if (!this.$v.codigoCondicion.mayorQueCero) errors.push("Elige la condición");
    return errors;
  }

  @Emit("close")
  onClose(): null {
    return null;
  }

  @Emit("cerrar-dialogo")
  onCerrarDialogo(): void {
    return;
  }

  @Emit("click-guardar")
  onClickGuardar(
    data: DataFormularioCondicionDivision
  ): DataFormularioCondicionDivision {
    return data;
  }

  //   @Watch("permisosKey", { immediate: true })
  //   onTipoChange(): void {
  //     console.log("a");
  //     for (const key of Object.keys(this.permisos)) {
  //       if (this.permisos[key]) {
  //         this.permisos[key] = false;
  //       }
  //     }
  //     this.permisosKey.forEach((key) => {
  //       this.permisos[key] = true;
  //     });
  //   }

  //   nombrePermiso(key: string): string {
  //     return this.rutas[key].text;
  //   }

  guardar(): void {
    this.$v.$touch();
    if (this.$v.$invalid || this.porcentajeError.length || this.descripcionError.length) {
      return;
    }
    // Códigos y mínimo se guardan como número ("0,45" → 0.45).
    const doc: CondicionDivision = {
      codigo_division: Number(this.codigoDivision),
      nombre_division: this.nombreDivision,
      moneda: this.moneda,
      escala: this.escala,
      indexacion: this.indexacion,
      minimo: aNumero(this.minimo),
      ...(this.usaPorcentaje && this.porcentaje !== ""
        ? { porcentaje: Math.round(aNumero(this.porcentaje) * 100) / 10000 }
        : {}),
      ...(this.esOtroCobro
        ? { descripcion: this.descripcion.trim(), base: this.base, exento: this.exento }
        : {}),
      aporte: this.aporte,
      operador: this.operador,
      origen: this.origen,
      codigo_contrato: Number(this.codigoContrato),
      codigo_condicion: Number(this.codigoCondicion),
    };
    if (this.id) {
      doc.id = this.id;
    }
    const data: DataFormularioCondicionDivision = {
      doc: doc,
    };
    this.onClickGuardar(data);
  }
}
